import ResizableScene from "./ResizableScene";

export default class ResizableContainer extends Phaser.GameObjects.Container {
    scene: ResizableScene;
    private _onResizeInternal = new Array<() => void>();

    constructor(scene: ResizableScene, x: number, y: number, children?: Phaser.GameObjects.GameObject[]) {
        super(scene, x, y, children);
        this.scene.scale.on(Phaser.Scale.Events.RESIZE, this.resize, this);
    }

    //Add callback to the resize event and calls it immediately
	addResize(onResize: () => void): void {
		this._onResizeInternal.push(onResize);
		onResize();
	}

    resize(): void {
        for (const onResize of this._onResizeInternal) {
			onResize();
		}
    }

    shutdown(): void {
        this._onResizeInternal = [];
        if(this.scene) this.scene.scale.off(Phaser.Scale.Events.RESIZE, this.resize, this);
    }

    destroy(): void {
        this._onResizeInternal = [];
        if(this.scene) this.scene.scale.off(Phaser.Scale.Events.RESIZE, this.resize, this);
        super.destroy();
    }
}
